import {navigateTo, useTranslation} from '#imports';

export function useProjectStateProps() {
    const {t} = useTranslation();

    async function brpSubmissionRedirect() {
        await navigateTo('/business-referral/submission?source=my-referrals', {
            open: {
                target: '_blank',
            },
        });
    }

    const projectStateProps = new Map()
        .set('EMPTY', {
            imageSrc: '/business-referral/security.png?vh=5b08f6',
            imgWidth: '188',
            title: t('business-referral.table.empty.title'),
            subtitle: t('business-referral.table.empty.subtitle'),
            projectStateCTA: {
                redirect: brpSubmissionRedirect,
                variant: 'primary',
                label: t('business-referral.table.empty.cta'),
            },
        })
        .set('APPROVED', {
            imageSrc: '/business-referral/meet-contractualize.png',
            imgWidth: '145',
            title: t('business-referral.details.status.approved.title'),
            subtitle: t('business-referral.details.status.approved.description'),
        })
        .set('CANCELLED', {
            imageSrc: '/business-referral/cancelled.svg',
            imgWidth: '135',
            title: t('business-referral.details.status.canceled.title'),
            subtitle: t('business-referral.details.status.canceled.description'),
        })
        .set('STAFFING_IN_PROGRESS', {
            imageSrc: '/business-referral/staffing-in-progress.png?vh=5ae82e',
            imgWidth: '145',
            title: t('business-referral.details.status.staffing.title'),
            subtitle: t('business-referral.details.status.staffing.description'),
        });

    function getProjectStateProps(state: string) {
        return projectStateProps.get(state);
    }

    return {getProjectStateProps, brpSubmissionRedirect};
}
